import { apiClient } from "@nabble/sdk";

/** A secondary email; once confirmed it can also be used to recover the password. */
export interface AccountEmail {
  id: string;
  email: string;
  verified: boolean;
  createdAt: string;
}

/** Starts a change of primary email: it only happens once the link sent to the new address is opened. */
export function changeEmail(email: string, currentPassword: string): Promise<void> {
  return apiClient<void>("/api/account/email", { method: "POST", body: { email, currentPassword } });
}

export function cancelPendingEmail(): Promise<void> {
  return apiClient<void>("/api/account/email/pending", { method: "DELETE" });
}

export function addEmail(email: string): Promise<{ id: string }> {
  return apiClient<{ id: string }>("/api/account/emails", { method: "POST", body: { email } });
}

export function resendEmailConfirmation(id: string): Promise<void> {
  return apiClient<void>(`/api/account/emails/${id}/resend`, { method: "POST" });
}

export function makeEmailPrimary(id: string, currentPassword: string): Promise<void> {
  return apiClient<void>(`/api/account/emails/${id}/primary`, { method: "POST", body: { currentPassword } });
}

export function removeEmail(id: string): Promise<void> {
  return apiClient<void>(`/api/account/emails/${id}`, { method: "DELETE" });
}

/** Public (no session): opens the link emailed to confirm an address. */
export function confirmEmail(token: string): Promise<{ email: string; primary: boolean }> {
  return apiClient<{ email: string; primary: boolean }>("/api/auth/email/confirm", { method: "POST", body: { token } });
}
